module.exports = __webpack_public_path__ + "static/img/paixu05.58ccd10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/paixu05.png
// module id = 117
// module chunks = 0